<template>
  <v-dialog v-model="showDialog" persistent max-width="800px">
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on">
        <v-list-item-icon>
          <v-icon color="success">mdi-clock-plus</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Créditer des heures</v-list-item-title>
      </v-list-item>
    </template>
    <v-card v-if="showDialog">
      <s-toolbar text="Créditer des heures" create @close="close()" />
      <v-card-text>
        <heures-credit-form v-model="ajouterHeuresCreditCommand" create @updateFormValid="updateFormValid" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="grey darken-1" text @click="close()">Annuler</v-btn>
        <v-btn color="success" :disabled="!formValid" @click="validate()"> Confirmer </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import HeuresCreditForm from './heures-credit-form'

export default {
  name: 'heures-credit-create-dialog',
  components: {
    HeuresCreditForm,
  },
  props: {
    employe: {
      type: Object,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      showDialog: false,
      formValid: false,
      ajouterHeuresCreditCommand: undefined,
    }
  },
  created() {
    this.initialize()
  },
  methods: {
    ...mapActions({
      ajouterHeuresCredit: 'employe/ajouterHeuresCredit',
    }),
    initialize() {
      this.ajouterHeuresCreditCommand = {
        employeId: this.employe ? this.employe.employeId : undefined,
        dateDapplication: undefined,
        nbHeures: undefined,
        raison: true,
        commentaire: undefined,
      }
    },
    updateFormValid(_validity) {
      this.formValid = _validity
    },
    validate() {
      if (this.formValid) {
        this.ajouterHeuresCredit(this.ajouterHeuresCreditCommand)
        this.close()
      }
    },
    close() {
      this.initialize()
      this.showDialog = false
    },
  },
}
</script>

<style scoped></style>
